/*eslint-disable lodash/prefer-lodash-method*/

const data = window.SPM_CONFIG;

export const landing = data.landing;



let integr = data.landing ? (data.landing.integrations || []) : [];

if (data.landing && !Array.isArray(data.landing.integrations)) {
  integr = [].concat(integr.web || []).concat(integr.install || []).concat(integr.smart_banner || []);
}


export const integrations = integr.filter(({ is_active }) => is_active);



// WEBPACK FOOTER //
// ./src/data-stores/LandingStore.js